// extracted by mini-css-extract-plugin
export var copyable = "_r-1";
export var explainable = "_r-0";
export var negative = "_r-2";
export var positive = "_r-3";